export default {
  buttons: {
    create: 'Erstellen',
    update: 'Aktualisieren',
    cancel: 'Abbrechen',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Titel eingeben',
    },
    description: {
      label: 'Beschreibung',
      placeholder: 'Beschreibung eingeben',
    },
    button_text: {
      label: 'Button-Text',
      placeholder: 'Button-Text eingeben',
    },
    button_url: {
      label: 'Button-URL',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Bild',
    },
  },
  title: 'Beitrag erstellen',
};
